import { checkIfBinary } from '@/utils';

export const getImagePreview = (image?: File | string) => {
  const imageUrl = !checkIfBinary(image) ? image : URL.createObjectURL(image as Blob);
  return imageUrl;
};
